import { CheckIcon } from "@signet/ui";
import { defineWebModule } from "@signet/web-kit";
import { TodoNowPanel } from "./now-panel.tsx";
import { TodoPage } from "./page.tsx";
import { TelegramPage } from "./telegram.tsx";
import { startReminders } from "./reminders.ts";
import "./todo.css";

/* The web half of To-do: its own page, and a panel on Now. */

const str = (value: unknown) => (typeof value === "string" && value ? value : undefined);

export default defineWebModule({
  id: "todo",
  nav: { label: "To-do", icon: CheckIcon, to: "/todo", needs: "todo.item:view" },
  routes: [
    { path: "/todo", component: TodoPage, needs: "todo.item:view", validateSearch: (raw) => ({ show: str(raw.show), open: str(raw.open) }) },
    // Jay's alone; the server answers 404 to anyone else (telegram.tsx).
    { path: "/todo/telegram", component: TelegramPage, needs: "todo.item:edit" },
  ],
  // The whole row under the four reporting and links panels (Jay, 2026-10-08).
  // Jay's day suggested from the notch in the desktop app (reminders.ts); answers 404 to anyone else and stops.
  background: { needs: "todo.item:edit", start: startReminders },
  nowPanels: [{ id: "todo.now", needs: "todo.item:view", order: 50, wide: true, component: TodoNowPanel }],
  commands: [
    { id: "todo.list", label: "To-do", to: "/todo", needs: "todo.item:view", hint: "The team's shared list", keywords: "todo tasks list jobs reminders" },
    { id: "todo.mine", label: "My to-dos", to: "/todo?show=mine", needs: "todo.item:view", hint: "To-do", keywords: "todo tasks assigned me" },
  ],
});
